/**
 * Backend base URL including /api (matches host.json routePrefix on Azure Functions).
 */
export function getApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_BASE_URL || "http://localhost:7071/api").trim();
  return raw.replace(/\/$/, "");
}

/**
 * GET JSON using the Phase 3 envelope: { ok, data, error }.
 */
export async function fetchJsonApi(path, init = {}) {
  const base = getApiBaseUrl();
  const pathPart = path.startsWith("/") ? path : `/${path}`;
  const url = `${base}${pathPart}`;
  const response = await fetch(url, init);
  const text = await response.text();
  let body;
  try {
    body = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(text?.slice(0, 200) || `Invalid JSON (HTTP ${response.status})`);
  }

  if (!response.ok) {
    const msg = body.error?.message || body.message || `HTTP ${response.status}`;
    const detail =
      body.error?.details?.message ??
      (typeof body.error?.details === "string" ? body.error.details : null);
    throw new Error(detail ? `${msg} ${detail}` : msg);
  }
  if (body.ok === false && body.error) {
    const msg = body.error.message || "Request failed";
    const detail =
      body.error?.details?.message ??
      (typeof body.error?.details === "string" ? body.error.details : null);
    throw new Error(detail ? `${msg} ${detail}` : msg);
  }
  return body.data;
}
